'use client';

import * as React from 'react';

interface SetupProcessorEmbedContextValue {
  processorId: string;
  onCancel: () => void;
  onComplete: () => void;
}

const SetupProcessorEmbedContext = React.createContext<SetupProcessorEmbedContextValue | null>(null);

interface SetupProcessorEmbedProviderProps {
  children: React.ReactNode;
  processorId: string;
  onCancel: () => void;
  onComplete: () => void;
}

export function SetupProcessorEmbedProvider({
  children,
  processorId,
  onCancel,
  onComplete,
}: SetupProcessorEmbedProviderProps) {
  const value = React.useMemo(
    () => ({ processorId, onCancel, onComplete }),
    [processorId, onCancel, onComplete],
  );

  return <SetupProcessorEmbedContext.Provider value={value}>{children}</SetupProcessorEmbedContext.Provider>;
}

export function useOptionalSetupProcessorEmbed() {
  return React.useContext(SetupProcessorEmbedContext);
}

export function useOptionalSetupProcessorEmbedProcessorId() {
  return React.useContext(SetupProcessorEmbedContext)?.processorId ?? null;
}
